import type { EditAsideFreeTextAuthors } from '@nodeTypeConfig/configTypes';
import { patchNodeAction } from '@store/actions/documentActions';
import { getResourceKey } from '@store/helpers/documentHelpers';
import { set } from 'lodash';
import { any } from 'prop-types';
import type React from 'react';
import { useDispatch } from 'react-redux';
import { useEditHref } from '../../../hooks/UseEditHref';
import { useInitialValue } from '../../../hooks/UseInitialValue';
import SimpleInput from '../asideSimpleInput/SimpleInput';

const AsideFreeTextAuthor: React.FC<{
  config: EditAsideFreeTextAuthors;
  readonly: boolean;
}> = ({ config, readonly }) => {
  const dispatch = useDispatch();

  const editHref = useEditHref();

  const currentValue = useInitialValue(config.property);

  const change = (value) => {
    dispatch(patchNodeAction(getResourceKey(editHref), set({}, config.property, value)));
  };

  return (
    <SimpleInput
      defaultValue={currentValue}
      label={config.label}
      readOnly={readonly}
      onChange={change}
    />
  );
};

export default AsideFreeTextAuthor;

AsideFreeTextAuthor.displayName = 'AsideFreeTextAuthor';

AsideFreeTextAuthor.propTypes = {
  config: any,
  readonly: any,
};
